import { createBrowserRouter, Navigate } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { PortalLayout } from "./components/layout/PortalLayout";
import { ClientArea } from "./pages/ClientArea";
import { AdminLogin } from "./pages/AdminLogin";
import { SSO } from "./pages/SSO";
import { Dashboard } from "./pages/Dashboard";
import { Portal } from "./pages/Portal";
import { Documents } from "./pages/Portal/Documents";
import { Documentos } from "./pages/Portal/Documentos";
import { Propostas } from "./pages/Portal/Propostas";
import { PropostaView } from "./pages/Portal/PropostaView";
import { Faturas } from "./pages/Portal/Faturas";
import { FaturaDetalhes } from "./pages/Portal/FaturaDetalhes";
import { Relatorios } from "./pages/Portal/Relatorios";
import { Contratos } from "./pages/Portal/Contratos";
import { PortalTickets } from "./pages/Portal/PortalTickets";
import { PortalNovoTicket } from "./pages/Portal/PortalNovoTicket";
import { PortalTicketDetails } from "./pages/Portal/PortalTicketDetails";
import { Gateway } from "./pages/Gateway";
import { HelpPage } from "./pages/Help";
import { PublicBriefing } from "./pages/PublicBriefing";
import { PortalBriefings } from "./pages/Portal/PortalBriefings";

const router = createBrowserRouter([
  // Redirecionar raiz para login admin
  {
    path: "/",
    element: <Navigate to="/admin/login" replace />,
  },
  // Admin Login (sem Layout/Header)
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  // SSO (autenticação via Zooy OS)
  {
    path: "/sso",
    element: <SSO />,
  },
  // Gateway mantido para acesso direto se necessário
  {
    path: "/gateway",
    element: <Gateway />,
  },
  // Página pública de briefing (link externo para prospects)
  {
    path: "/public/briefing/:token",
    element: <PublicBriefing />,
  },
  // Layout Institucional (Site Público)
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/area-cliente",
        element: <ClientArea />,
      },
    ],
  },
  // Layout do Workspace (Portal do Cliente)
  {
    path: "/portal",
    element: <PortalLayout />,
    children: [
      {
        index: true,
        element: <Portal />,
      },
      {
        path: "tickets",
        element: <PortalTickets />,
      },
      {
        path: "tickets/novo",
        element: <PortalNovoTicket />,
      },
      {
        path: "tickets/:id",
        element: <PortalTicketDetails />,
      },
      {
        path: "documentos",
        element: <Documentos />,
      },
      {
        path: "documentos/:tipoId",
        element: <Documents />,
      },
      {
        path: "propostas",
        element: <Propostas />,
      },
      {
        path: "propostas/:id",
        element: <PropostaView />,
      },
      {
        path: "faturas",
        element: <Faturas />,
      },
      {
        path: "faturas/:id",
        element: <FaturaDetalhes />,
      },
      {
        path: "relatorios",
        element: <Relatorios />,
      },
      {
        path: "contratos",
        element: <Contratos />,
      },
      {
        path: "briefings",
        element: <PortalBriefings />,
      },
      {
        path: "ajuda",
        element: <HelpPage variant="client" />,
      },
    ],
  },
  // Dashboard Admin (separado)
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  // Central de Ajuda — Administração (equipe interna)
  {
    path: "/ajuda",
    element: <HelpPage variant="admin" />,
  },
  // Redirecionamentos
  {
    path: "/admin/atendimentos/*",
    element: <Navigate to="/dashboard" replace />,
  },
]);

export { router };
